import Keycloak from "keycloak-js";

export const initOptions = {
  url: import.meta.env.VITE_KEYCLOAK_IDP ?? "https://development.identity.harleydikkinson.com",
  realm: import.meta.env.VITE_REALM_NAME ?? "HarleyDikkinson",
  clientId: import.meta.env.VITE_CLIENT_ID ?? "happyway",
};

export const keycloak = new Keycloak(initOptions);

export const storeToken = () => {
  if (keycloak) {
    localStorage.setItem("kc_token", keycloak.token);
    localStorage.setItem("kc_refreshToken", keycloak.refreshToken);
  }
};

export const loadToken = () => ({
  token: localStorage.getItem("kc_token"),
  refreshToken: localStorage.getItem("kc_refreshToken"),
});

export const refreshToken = () => {
  setInterval(async () => {
    // const now = Date.now();
    // // const currentTime = Math.floor(now / 1000); // Tempo attuale in secondi (Unix Timestamp)
    // // const tokenExpiryTime = keycloak.tokenParsed.exp; // Tempo di scadenza del token
    // const timeString = new Date(now).toLocaleTimeString('it-IT', { hour: 'numeric', minute: 'numeric', second: 'numeric' });
    // console.log(timeString)

    keycloak
      .updateToken(99999)
      .then((refreshed) => {
        if (refreshed) {
          storeToken();
        }
      })
      .catch(() => {
        console.error("Token refresh failed, logging out");
        // logout(); // Da rivedere con userStore
      });
  }, 300000); // Check every 5 min
};

export const logout = async () => {
  localStorage.removeItem("kc_token");
  localStorage.removeItem("kc_refreshToken");
  await keycloak.logout({ redirectUri: window.location.origin });
};

export const clearToken = async () => {
  keycloak.clearToken();
};
